import script from "./SideMenuTabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./SideMenuTabs.vue?vue&type=script&lang=ts&setup=true"

import "./SideMenuTabs.vue?vue&type=style&index=0&id=09b1e35e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09b1e35e"]])

export default __exports__